import React from 'react';
import classNames from 'classnames';
import './sort-button.scss';

const SortButton = props => {
    return (
        <button className={classNames({
            'sort-button':true,
            'sort-button--asc': props.sortOrder.key === props.sortkey && props.sortOrder.direction === 'asc',
            'sort-button--desc': props.sortOrder.key === props.sortkey && props.sortOrder.direction === 'desc',
            ...props.modifiers
        })} disabled={props.dataIsLoading} onClick={() => props.onClick(props.sortkey)}>{props.children}</button>
    );
};

export default SortButton;